import React, { useState } from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import LoggedAdmin from '../../../Api/Models/LoggedAdmin';
import useGlobalState from '../../GlobalStateContext';
import SweetAlert from '../../elements/alerts/SweetAlert';
import Card from '../../elements/common/Card';
import AdminForm from '../admin/AdminForm';

import { ValidationErrors } from 'crm/helpers/ResponseErrorHelper';

export default function EditProfile() {
    const [errors, setErrors] = useState<ValidationErrors>({});
    const { loggedAdmin, setLoggedAdmin } = useGlobalState();

    const handleEditProfile = (updatedProfile) => {
        CRMApi.post('profile/edit', updatedProfile)
            .then((response) => {
                setLoggedAdmin(new LoggedAdmin(response.data));
                SweetAlert.success('Profile updated correctly');
            })
            .catch((error) => {
                setErrors(error.response.data.errors);
            });
    };

    return (
        <Card title="Update profile">
            <AdminForm action={handleEditProfile} errors={errors} adminData={loggedAdmin} profile />
        </Card>
    );
}
